import React from 'react';
import { ToastContainer } from './ui/Toast';
import { useToast } from '../contexts/ToastContext';

const GlobalToastContainer = () => {
  const { toasts, dismissToast } = useToast();
  
  return <ToastContainer toasts={toasts} onDismiss={dismissToast} />;
};

export default GlobalToastContainer;
